/** 工行数币一分钱乘车3月活动 - 活动介绍页 */
<template>
  <div class="main-box">
    <img
      src="https://oss.aqdpay.com/appweb/aPennyRide/digitalCurrencyForICBC/MarActivity/1.png"
      alt=""
    />
    <div class="activity-rules">
      <img
        src="https://oss.aqdpay.com/appweb/aPennyRide/digitalCurrencyForICBC/MarActivity/2.png"
        alt=""
      />
      <div class="guide-btn" @click="handleGuide">升级指引</div>
      <div class="intro-btn" @click="handleMore">更多常见问题</div>
      <!-- <img
        src="https://oss.aqdpay.com/appweb/aPennyRide/digitalCurrencyForICBC/upgrade_btn.png"
        alt=""
        class="upgrade-btn"
        @click="handleUpgrade"
      /> -->
    </div>
    <img
      src="https://oss.aqdpay.com/appweb/aPennyRide/digitalCurrencyForICBC/MarActivity/3.png"
      alt=""
    />
    <!--    <img-->
    <!--      src="https://oss.aqdpay.com/appweb/aPennyRide/digitalCurrencyForICBC/activity4.png"-->
    <!--      alt=""-->
    <!--    />-->
  </div>
</template>
<script>
export default {
  name: 'digitalCurrencyForICBCIndex',
  methods: {
    // 点击查看更多常见问题
    handleMore () {
      this.$router.push('/introICBC')
    },
    handleGuide () {
      this.$router.push('/digitalMarActivityGuide')
    },
    // 点击去升级
    handleUpgrade () {
      window.location.href = 'https://dcwt.icbc.com.cn:8443/icbc/dcwt-h5/#/open-wallet-apply?channel=22&cmosCode=&marketChannel=000000002&marketCode=000828088&saleActionId=26725043865998540815'
    }
  }
}
</script>
<style lang="scss" scoped>
.main-box {
  img {
    display: flex;
    width: 100%;
    height: auto;
  }
}

.note-intro,
.activity-rules {
  position: relative;
}

.intro-btn {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 10px;
  width: 100vw;
  height: 232px;
  margin: 0 auto;
  text-align: center;
  color: transparent;
}

.guide-btn {
  position: absolute;
  left: 0;
  right: 0;
  top: 10px;
  width: 100vw;
  height: 432px;
  text-align: center;
  color: transparent;
}

.activity-rules .upgrade-btn {
  position: absolute;
  bottom: 3%;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 80%;

  &:active {
    opacity: 0.8;
  }
}

</style>
